export const getTabDisplayState = ({ hasRows, isFetching, isFetchingNextPage, isLoading }) => {
  const showFullLoader = isLoading || (isFetching && !isFetchingNextPage);
  const showContent = !showFullLoader && hasRows;
  const showEmpty = !showFullLoader && !hasRows;
  const showNextPageLoader = showContent && isFetchingNextPage;

  return {
    showContent,
    showEmpty,
    showFullLoader,
    showNextPageLoader,
  };
};
